const createQuery = () => `
  ... on ExecutivesInCompanyWidget {
    id
    executives {
      name
      slug
      jobTitle
      images {
        headshot_220x347_220 {
          url
        }
      }
    }
  }
`

export default createQuery
